import { render, staticRenderFns } from "./CtaBannerFixed.vue?vue&type=template&id=4298931c&scoped=true"
import script from "./CtaBannerFixed.vue?vue&type=script&lang=js"
export * from "./CtaBannerFixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298931c",
  null
  
)

export default component.exports